import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "calendar" }
const _hoisted_2 = { class: "calendar__section" }
const _hoisted_3 = { class: "dayCount" }
const _hoisted_4 = { class: "dayCount__names" }
const _hoisted_5 = { class: "dayCount__days" }
const _hoisted_6 = ["onClick"]

import { computed, ref, toRefs } from "@vue/reactivity";

import { useCalendarStore } from "@/store/calendar";
import { onMounted, watch } from "@vue/runtime-dom";
import { useUserDaysStore } from "@/store/userDays";
import MonthDialog from "@/components/UI/DialogViews/MonthDialog.vue";
import SetdayDialog from "@/components/UI/DialogViews/SetdayDialog.vue";
import DaySummary from "@/components/UI/DialogViews/DaySummary.vue";
import TopBar from "@/components/TopBar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarView',
  setup(__props) {

_useCssVars(_ctx => ({
  "1485aafa": (_unref(monthStartDay))
}))

const calendarStore = useCalendarStore();
const userDaysStore = useUserDaysStore();

const year = toRefs(calendarStore).year;
const month = toRefs(calendarStore).month;
const weekDays = ["Pon", "Wt", "Śr", "Czw", "Pt", "Sob", "Nd"];
const monthDialog = ref(false);
const dayDialog = ref(false);
const setDayDialog = ref(false);
const checkedDay = ref(0);
const checkedMonth = computed(() => {
  const months = [
    "",
    "Styczeń",
    "Luty",
    "Marzec",
    "Kwiecień",
    "Maj",
    "Czerwiec",
    "Lipiec",
    "Sierpień",
    "Wrzesień",
    "Październik",
    "Listopad",
    "Grudzień",
  ];
  return `${months[month.value]} ${year.value}`;
});

const daysLoading = ref(false);

const checkedDate = computed(() => {
  return { year, month, day: checkedDay };
});

const monthStartDay = computed(() => {
  return calendarStore.monthStartDay;
});
const isHoliday = (day: number) => {
  const dayOfWeek = new Date(year.value, month.value - 1, day).getDay();
  const holidays = calendarStore.holidaysAtMonth;
  if (dayOfWeek === 0 || holidays.includes(day)) return true;
};

const dayClass = (day: number) => {
  const usedDays = [];
  for (const item of userDaysStore.dailyInfo) {
    usedDays.push(Number(item.day));
  }
  const isChecked = usedDays.includes(day);
  let checkedDay;

  if (isChecked) {
    checkedDay = userDaysStore.dailyInfo.filter((el) => {
      return el.day === day;
    });
  } else return;

  return checkedDay[0].group;
};

const dayIsDone = (day: number) => {
  const usedDays = [];
  for (const item of userDaysStore.dailyInfo) {
    usedDays.push(Number(item.day));
  }

  return usedDays.includes(day);
};

const openDayDialog = (day: number) => {
  checkedDay.value = day;
  dayDialog.value = true;
};
const openMonthDialog = () => {
  monthDialog.value = true;
};
const openSetDay = () => {
  setDayDialog.value = true;
};
const closeDayDialog = () => {
  dayDialog.value = false;
};
const closeMonthDialog = () => {
  monthDialog.value = false;
};
const closeSetDay = () => {
  closeDayDialog();
  setDayDialog.value = false;
};

const loadDailyInfo = async () => {
  daysLoading.value = true;
  try {
    await userDaysStore.fetchMonhlyData();
  } catch (error: string | unknown) {
    console.log(error);
  }
  daysLoading.value = false;
};

onMounted(() => {
  loadDailyInfo();
});

watch(year, loadDailyInfo);
watch(month, loadDailyInfo);

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(TopBar, { class: "calendar__header" }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("span", { onClick: openMonthDialog }, _toDisplayString(_unref(checkedMonth)), 1),
          (_unref(monthDialog))
            ? (_openBlock(), _createBlock(MonthDialog, {
                key: 0,
                onClose: closeMonthDialog,
                title: "Wybór miesiąca"
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("main", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(weekDays, (item) => {
          return _createElementVNode("div", {
            class: _normalizeClass(["dayCount__name", { 'dayCount__item--sunday': item === 'Nd' }]),
            key: item
          }, _toDisplayString(item), 3)
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(daysLoading))
          ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(calendarStore).daysCount, (n) => {
              return (_openBlock(), _createElementBlock("div", {
                onClick: ($event: any) => (openDayDialog(n)),
                class: _normalizeClass(["dayCount__item", [
            { 'dayCount__item--sunday': isHoliday(n) },
            `dayCount__item--${dayClass(n)}`,
          ]]),
                key: n
              }, _toDisplayString(n), 11, _hoisted_6))
            }), 128)),
        (_unref(dayDialog) && dayIsDone(_unref(checkedDate).day.value))
          ? (_openBlock(), _createBlock(DaySummary, {
              key: 2,
              title: "Podsumowanie dnia",
              onClose: closeDayDialog,
              onCloseDaySummary: closeDayDialog,
              onEditMode: openSetDay,
              date: _unref(checkedDate)
            }, null, 8, ["date"]))
          : _createCommentVNode("", true),
        (
            _unref(setDayDialog) || (_unref(dayDialog) && !dayIsDone(_unref(checkedDate).day.value))
          )
          ? (_openBlock(), _createBlock(SetdayDialog, {
              key: 3,
              title: "Ustawienia dnia",
              onClose: closeSetDay,
              onCloseSetDayDialog: closeSetDay,
              date: _unref(checkedDate)
            }, null, 8, ["date"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})